import { isEmpty } from 'lodash'

const ingredientImageFormInitialValues = values => ({
  id: values.id,
  image: isEmpty(values.imageUrl)
    ? []
    : [{ uid: '0', status: 'done', url: values.imageUrl }],
})

export default ingredientImageFormInitialValues
